import { get } from '@ember/object';
import { service } from '@ember/service';
import Super from './-resource';

export default class SiteAppointmentsRequested extends Super {
  @service currentPractice;
  @service prospectiveClient;
  @service router;

  beforeModel() {
    if (get(this.currentPractice, 'useBookAppointmentLanguage')) {
      this.router.transitionTo('site.appointments.upcoming');
      return;
    }

    let { prospectiveClient } = this;

    if (prospectiveClient.useProspectiveClientFlow) {
      let route = prospectiveClient.recommendedRoute;
      if (route !== 'site.appointments.requested') {
        this.router.transitionTo(route);
      }
    }
  }

  model() {
    return this._model({ hasPendingConfirmation: true });
  }
}
